import React from "react";
import { X, Loader2, UserPlus, Phone } from "lucide-react";

/**
 * ImportContactModal — extracted from ChatsPage.jsx (iter 156.2, Feb 2026).
 * Manually imports a WhatsApp contact via WATI by phone number — used when
 * the periodic auto-sync hasn't picked up a new lead yet.
 */
export const ImportContactModal = ({
  open,
  onClose,
  importPhone,
  setImportPhone,
  importing,
  onImport,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="import-contact-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm animate-scale-in">
        <div className="flex items-center justify-between p-4 border-b border-[--border]">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center"><UserPlus size={16} /></span>
            <h2 className="text-sm font-semibold" style={{ fontFamily: "Playfair Display, serif" }}>Import Contact from WATI</h2>
          </div>
          <button onClick={() => { onClose(); setImportPhone(""); }} className="btn-icon"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-3">
          <div>
            <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Phone Number *</label>
            <div className="flex items-center gap-2 bg-[--bg-cream] border border-[--border] rounded-lg px-3 py-2">
              <Phone size={14} className="text-[--text-muted]" />
              <input
                type="text"
                value={importPhone}
                onChange={(e) => setImportPhone(e.target.value)}
                placeholder="919821791175"
                className="flex-1 text-sm bg-transparent outline-none placeholder:text-[--text-muted]"
                data-testid="import-phone-input"
                autoFocus
                onKeyDown={(e) => e.key === "Enter" && onImport()}
              />
            </div>
            <p className="text-[10px] text-[--text-muted] mt-1">Enter the WhatsApp number with country code (e.g., 919821791175)</p>
          </div>
          <div className="text-[11px] text-[--text-muted] bg-[--bg-cream] rounded-lg p-2.5">
            <p>This will import the contact and their message history from WATI if auto-sync hasn't picked them up yet.</p>
          </div>
          <button onClick={onImport} disabled={importing || !importPhone.trim()}
            className="w-full btn-primary py-2.5 justify-center" data-testid="import-contact-submit-btn">
            {importing ? <Loader2 size={14} className="animate-spin" /> : <><UserPlus size={14} /> Import Contact</>}
          </button>
        </div>
      </div>
    </div>
  );
};
